import { notifications } from '@mantine/notifications'

const success = (message: string) => {
  notifications.show({
    message,
    color: 'success',
  })
}

const info = (
  message: string,
  id?: string,
  autoClose?: boolean,
  withCloseButton?: boolean,
) => {
  notifications.show({
    id,
    message,
    color: 'primary',
    autoClose,
    withCloseButton,
  })
}

const hide = (id: string) => {
  notifications.hide(id)
}

const error = (message: string) => {
  notifications.show({
    message,
    color: 'error',
  })
}

export const toast = { success, info, hide, error }
